<template>
  <div class="counter">
    <label for="counter-minus" class="iw-visuallyhidden">Quantity decrement</label>
    <button
      id="counter-minus"
      class="counter__button minus"
      :class="{ disabled: isMinimumReached }"
      :disabled="isMinimumReached"
      @click="reduce"
    ></button>
    <label for="counter" class="iw-visuallyhidden">Quantity</label>
    <input id="counter" type="text" class="counter__qty" :value="getCount" readonly />
    <label for="counter-plus" class="iw-visuallyhidden">Quantity increment</label>
    <button
      id="counter-plus"
      class="counter__button plus"
      :class="{ disabled: isMaximumReached }"
      :disabled="isMaximumReached"
      @click="increase"
    ></button>
  </div>
</template>

<script>
export default {
  name: "AppCounter",
  props: {
    modelValue: Number,
    max: Number,
    min: Number,
    isDisabled: Boolean
  },
  data() {
    return {
      count: +this.modelValue,
      maxQty: +this.max ?? Infinity,
      minQty: this.min ?? 1,
      counterDisabled: this.isDisabled
    };
  },
  computed: {
    getCount() {
      if (this.count > this.minQty) return this.count;

      this.count = this.minQty;
      this.$emit("update:modelValue", this.count);
      return this.count;
    },
    isMinimumReached() {
      return this.count === this.minQty;
    },
    isMaximumReached() {
      return this.counterDisabled || this.count >= this.maxQty;
    }
  },
  methods: {
    increase: function () {
      this.count++;
      this.$emit("update:modelValue", this.count);
    },
    reduce: function () {
      this.count--;
      this.$emit("update:modelValue", this.count);
    }
  }
};
</script>

<style scoped lang="scss">
.disabled {
  opacity: 0.5;
}

.plus,
.minus {
  cursor: pointer;
  position: relative;
}

.plus:before,
.plus:after,
.minus:before {
  position: absolute;
  top: 14px;
  content: "";
  height: 12px;
  width: 2px;
  background-color: $group-3-color-3;
}

.plus:before {
  transform: rotate(-90deg);
}

.minus:before {
  transform: rotate(90deg);
}

.counter {
  display: flex;
  position: relative;
  border-radius: 46px;
  border: solid 2px $group-3-color-4;
  overflow: hidden;
  box-sizing: border-box;
  height: 46px;

  &__qty {
    box-sizing: border-box;
    margin-top: 0.4em;
    width: 2em;
    height: 2em;
    outline: none;
    text-align: center;
    font-size: inherit;
    border: none;
  }

  &__button {
    width: 70px;
    outline: none;
    border: none;
    font-size: inherit;
    background: none;
  }
}
</style>
